/** 
  * This is a web reset. On native, all global stylesheets are automatically ignored.
  * CSS is enabled via metro.config.js.
  */

@layer reset {
    html {
        font-family: sans-serif;
        /* Something is adding 'scrollbar-gutter: stable' when a Tamagui Dialog opens
           which adds a useless ~20px white gap on the right side of the page */
        scrollbar-gutter: auto !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-height: 100svh !important;
    }

    body {
        overflow-x: hidden;
        /* prevent safari from making our custom font too bold */
        font-synthesis-style: none !important;
        font-synthesis-weight: none !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-height: 100svh !important;
    }

    body,
    #root {
        overflow: visible;
    }

    * {
        box-sizing: border-box;
    }

    a {
        color: inherit;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
        padding: 0;
    }

    li,
    select,
    input,
    button,
    [role='slider'],
    [role='listbox'] {
        outline: none;
    }

    .is_Fieldset {
        all: unset;
    }

    p,
    input,
    textarea,
    button,
    ul,
    ol,
    li,
    pre,
    dialog {
        all: unset;
        box-sizing: border-box;
    }

    a.is_Button,
    .is_Anchor:has(.is_Button) {
        text-decoration: none;
    }

    svg:focus {
        outline: none;
    }
}
